import { useAuth } from "providers";
import { ReactNode } from "react";
import { Navigate } from "react-router-dom";

type RequireAuthType = { children: ReactNode };

const RequireAuth = ({ children }: RequireAuthType) => {
  const { isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/authentication" replace />;
  }

  return <>{children}</>;
};

export default RequireAuth;
